import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]">
      <div className="w-full max-w-sm">
        {done ? (
          <div className="text-center" data-testid="forgot-confirmation">
            <MailCheck className="w-12 h-12 text-[#E8791A] mx-auto mb-3" />
            <h2 className="font-head text-2xl font-bold">Check your email</h2>
            <p className="text-sm text-slate-500 mt-2">
              If that email is registered, a reset link has been sent. The link expires in 1 hour.
            </p>
            <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#E8791A] hover:underline mt-6">
              <ArrowLeft className="w-4 h-4" /> Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h2 className="font-head text-2xl font-bold text-slate-900">Reset password</h2>
            <p className="text-sm text-slate-500 mb-6">Enter your email to receive a reset link.</p>
            {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>}
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   className="mt-1" data-testid="forgot-email-input" />
            <Button type="submit" disabled={loading} className="w-full mt-6 bg-[#0B192C] hover:bg-[#142843]"
                    data-testid="forgot-submit-button">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Send reset link
            </Button>
            <div className="text-center mt-4">
              <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#E8791A] hover:underline">
                <ArrowLeft className="w-4 h-4" /> Back to sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
